import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { useMemo } from 'react';

import { type LevelItemWithLevel } from '../../types';
import { TopicCollapsible } from '../topic-collapsible';

export interface RenderTopicCollapsibleProps {
  location: {
    topics: Record<string, boolean | null | undefined>;
    subtopics: Record<string, boolean | null | undefined>;
  };
  levelItemsWithLevel: Array<LevelItemWithLevel>;
}
export default function RenderTopicCollapsible(props: Readonly<RenderTopicCollapsibleProps>) {
  const { location, levelItemsWithLevel } = props;

  return useMemo(() => {
    const activeTopics = Object.entries(location.topics)
      .filter(([, value]) => value)
      .map(([key]) => {
        const structure = levelItemsWithLevel.find((s) => s.id === key);
        return {
          key,
          // Only a topic has a topic name; the chapter used as topic falls back below.
          name:
            structure?.level.category === QBankStructureLevelCategory.Topic
              ? structure?.tag?.name
              : undefined,
          order:
            structure?.level.category === QBankStructureLevelCategory.Topic
              ? (structure?.order ?? null)
              : null,
        };
      })
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    const subtopicKeys = Object.entries(location.subtopics)
      .filter(([, value]) => value)
      .map(([key]) => key);
    return activeTopics.map(({ key, name, order }) => {
      const topicChildren = levelItemsWithLevel.filter((s) => s.parentLevelItemId === key);
      let subTopicsNames = topicChildren
        .filter((topic) => subtopicKeys.includes(topic.id))
        .sort((a, b) => a.order - b.order)
        .map((topic) => topic.tag?.name)
        .filter((name) => name !== undefined);

      if (subTopicsNames.length === topicChildren.length) {
        subTopicsNames = ['All Sub-Topics'];
      }
      let topicName = name;
      if (!topicName) {
        topicName = order === 0 ? 'หัวข้อ: ไม่ระบุ' : 'หัวข้อ: ไม่เปิดใช้งาน';
      }

      return <TopicCollapsible key={key} topicName={topicName} subTopicNames={subTopicsNames} />;
    });
  }, [location.topics, location.subtopics, levelItemsWithLevel]);
}
